/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEmploymentAppDataRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateEmploymentAppDataResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateEmploymentAppData = (request: UpdateEmploymentAppDataRequest, options?: CashRequestOptions) => post<UpdateEmploymentAppDataRequest, UpdateEmploymentAppDataResponse>("/2.0/cash/update-employment-app-data", request, {...options, rejectOnError: true })